import React, { useRef } from "react";
import { Dropdown }          from "primereact/dropdown";

const ComboBox = ({
    seleccionable,
    value,
    ...props
}) => {
    let componente = null;
    if(seleccionable){
        componente = <Dropdown value={value} {...props} />;
    }else{
        componente = value
    }
    return componente;

};

export default ComboBox;